<gbc-page-error-handler [content]="content" [pageError$]="pageError$">
</gbc-page-error-handler>
<ng-template #content>
  @if (route.children.length !== 0) {
    <router-outlet></router-outlet>
  }
  @if (route.children.length === 0) {
    @if (isBuildingConnect$ | async) {
      <app-building-connect-installation-page [installation$]="installation$" [facility$]="facility$" [schematic$]="schematic$"></app-building-connect-installation-page>
    }
    @if (isMixit$ | async) {
      <app-mixit-installation-page [installation$]="installation$" [facility$]="facility$" [schematic$]="schematic$"></app-mixit-installation-page>
    }
    @if (isConnectingCore$ | async) {
      <app-connectingcore-installation-page [installation$]="installation$" [facility$]="facility$" [schematic$]="schematic$"></app-connectingcore-installation-page>
    }
  }
</ng-template>
